import React from 'react';
import DashboardWeb from './DashboardWeb';
import DashboardMobile from './index.mobile.js';
import helper from '../../../utils/helper';
import moment from 'moment';

function Dashboard(props) {
  const timeStart = moment();
  const timeOutMin = helper.getSetting('SessionTimeoutMinutes').value;
  const [isMobile, setIsMobile] = React.useState(
    localStorage.getItem('isMobile'),
  );
  React.useEffect(() => {
    if (isMobile === null) {
      localStorage.setItem('isMobile', helper.isMobile());
      setIsMobile(helper.isMobile());
    }
    return function cleanUp() {
      const diff = moment().diff(timeStart, 'minutes');
      if (diff > parseFloat(timeOutMin)) {
        props.history.push('/login');
      }
    };
  }, []);
  if (isMobile === 'true' || isMobile === true) {
    return (
      <DashboardMobile
        {...props}
        isMobile={isMobile}
        setIsMobile={setIsMobile}
      />
    );
  } else {
    return (
      <DashboardWeb {...props} isMobile={isMobile} setIsMobile={setIsMobile} />
    );
  }
}

export default Dashboard;
